import APIClient from '@/shared/http/clients/api'

const resourceName = 'QMAConsultas'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const InqueryAproveReprovedForm = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/InqueryAproveReprovedForm/`, data, config)
const GetMediasForm = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetMediasForm/`, data, config)
const GetAllLvPitPivs = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllLvPitPivs?limit=${limit}&index=${index}`, data, config)
const GetLogQma = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetLogQma/${id}`, data, config)
const GetQmaMedias = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetQmaMedias/`, data, config)
const getSignatureQma = (id, limit, index, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/getSignatureQma/${id}?limit=${limit}&index=${index}`, data, config)
const GetDetails = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetDetails/${id}`, data, config)
const GetInfo = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetInfo/${id}`, data, config)
const GetCabecalho = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetCabecalho/${id}`, data, config)
const GetAllStatusQma = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAllStatusQma/`, data, config)
const GetTemplatesByFluxo = (fluxo, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetTemplatesByFluxo/${fluxo}`, config)
const GetHeaderFieldsByTemplate = (templateId, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetHeaderFieldsByTemplate/${templateId}`, config)
const PopUpQmaRepForm = (id, aprRep, motivo, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/PopUpQmaRepForm/${id}/${aprRep}/${motivo}`, data, config)
const GetQmaSelected = (idQma, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetQmaSelected/${idQma}`, data, config)
const GetVerificacao = (id, ReferenciaId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetVerificacao/${id}/${ReferenciaId}`, data, config)
const GetImagemSelecionada = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetImagemSelecionada/`, data, config)
const GetFotoSelecionada = (id, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetFotoSelecionada/${id}`, data, config)
const GetOpcaoSelecionado = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetOpcaoSelecionado/${id}`, data, config)
const GetImagemPergunta = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetImagemPergunta/`, data, config)
const getSignatureQmaUrl = (url, data = {}, config = {}) => {
  const requestBody = {
    url: url,
    ...data
  }
  return APIClient.post(`${APIBusinessCommon}/${resourceName}/getSignatureQmaUrl`, requestBody, config)
}
const EditInfoAssinaturaQma = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/EditInfoAssinaturaQma`, data, config)
const SugestaoVinculoSap = (id, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/SugestaoVinculoSap/${id}`, config)
const AprovarEngenheiro = (id, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/AprovarEngenheiro/${id}`, {}, config)
const AprovarCoordenador = (id, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/AprovarCoordenador/${id}`, {}, config)
const ReprovarQMA = (id, motivo, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/ReprovarQMA/${id}`, JSON.stringify(motivo), { headers: { 'Content-Type': 'application/json' }, ...config })
const SoftDeleteQMA = (id, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/SoftDelete/${id}`, {}, config)
const VoltarStatusQMA = (id, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/VoltarStatus/${id}`, {}, config)

const inqueryQmaRepository = {
  InqueryAproveReprovedForm,
  GetMediasForm,
  GetLogQma,
  GetQmaMedias,
  getSignatureQma,
  GetDetails,
  GetInfo,
  // GetAllLv,
  // GetAllPit,
  // GetAllPivs,
  GetAllLvPitPivs,
  SugestaoVinculoSap,
  GetAllStatusQma,
  GetTemplatesByFluxo,
  GetHeaderFieldsByTemplate,
  PopUpQmaRepForm,
  GetQmaSelected,
  GetVerificacao,
  GetImagemSelecionada,
  GetOpcaoSelecionado,
  GetImagemPergunta,
  getSignatureQmaUrl,
  GetCabecalho,
  EditInfoAssinaturaQma,
  GetFotoSelecionada,
  AprovarEngenheiro,
  AprovarCoordenador,
  ReprovarQMA,
  SoftDeleteQMA,
  VoltarStatusQMA
}

export default inqueryQmaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/qmaInquery.js